export const ScrollRevealText = ({ text }: { text: string }) => {
  return (
    <div 
      className="relative flex w-full items-center justify-center overflow-visible pt-20 pb-2"
    >
      <h1
        className="w-full text-center text-[18vw] tracking-[0.1em] text-primary leading-[0.85] select-none"
        style={{ fontFamily: "'Flames', sans-serif", transformOrigin: "bottom", textShadow: "0 0 40px rgba(255, 90, 31, 0.4)" }}
      >
        {text}
      </h1>
    </div>
  );
};
